// mutation 常量
export const SET_MENU_LIST = 'SET_MENU_LIST';
export const SET_SHEET_VISIBLE = 'SET_SHEET_VISIBLE';
export const SET_AUTHORITIES = 'SET_AUTHORITIES';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js